import { apiSlice } from "./apiSlice";

export const erpDataSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all ERP data
        getErpData: builder.query({
            query: (params) => ({
                url: `CertificateDetailsReport`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllErpData"],
        }),

        // Create new ERP data
        createErpData: builder.mutation({
            query: ({ body }) => ({
                url: `CertificateDetailsReport/import`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllErpData"],
        }),

        getExportErpData: builder.query({
            query: (params) => ({
                url: `CertificateDetailsReport`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),



    })
})

export const { useLazyGetErpDataQuery, useGetErpDataQuery, useCreateErpDataMutation, useLazyGetExportErpDataQuery } = erpDataSlice;
